import {
  Container,
  Heading,
  Text,
  Image,
  Box,
  Divider,
  Flex,
  Button,
} from "@chakra-ui/react";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { base_url } from "../../utils/utils";

const BlogDetails = () => {
  const { state } = useLocation();
  const blog = state?.blog;
  const navigate = useNavigate();

  if (!blog) {
    return (
      <Container>
        <Text>Blog not found</Text>
      </Container>
    );
  }

  return (
    <Container maxW="container.xl" py={8}>
 <Button 
        mb={4} 
        onClick={() => navigate(-1)}
        bg="yellow.400"
        color="white"
      >        Back to Blogs
      </Button>

      <Heading as="h1" size="xl" mb={6}>
        {blog.title}
      </Heading>

      <Box mb={6}>
        <Image
          src={base_url + blog.image}
          alt={blog.alt_text || blog.title}
          maxH="500px"
          objectFit="contain"
          mx="auto"
        />
      </Box>

      <Divider my={6} />

      <Box mb={6}>
        <Heading as="h2" size="md" mb={2}>
          Description
        </Heading>
        <Box
          dangerouslySetInnerHTML={{ __html: blog.description }}
          className="blog-content"
        />
      </Box>

      <Divider my={6} />

      <Box mb={6}>
        <Heading as="h2" size="md" mb={2}>
          Meta Description
        </Heading>
        <Text>{blog.meta_description}</Text>
      </Box>

      {blog.alt_text && (
        <>
          <Divider my={6} />
          <Box mb={6}>
            <Heading as="h2" size="md" mb={2}>
              Alt Text
            </Heading>
            <Text>{blog.alt_text}</Text>
          </Box>
        </>
      )}
    </Container>
  );
};

export default BlogDetails;